import { styled } from '@mui/material'
import Card from '@mui/material/Card'
import { Submission } from '@global/types'
import { SubmissionStatusStepperV2 } from '@submissions/submissions/components/submissionStatusStepperV2'
import { phaseProgressMap, steps } from '@submissions/submissions/config'

const OverallStatusCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  padding-left: 45px;
  padding-right: 45px;
`

interface OverallStatusProps {
  submission: Submission
  creativeClassificationEnabled: boolean
}

export const OverallStatus = ({
  submission,
  creativeClassificationEnabled,
}: OverallStatusProps) => {
  const submissionSteps = steps(null, creativeClassificationEnabled)
  return (
    <OverallStatusCard elevation={0}>
      <SubmissionStatusStepperV2
        submission={submission}
        steps={submissionSteps}
        progressMap={phaseProgressMap}
        creativeClassificationEnabled={creativeClassificationEnabled}
      />
    </OverallStatusCard>
  )
}
